<template>
    <div class="modal-vue" :id="id" v-if="value">
        
        <div class="modal-vue-overlay animated fadeIn"> </div>
        
        <div class="modal-vue-frame animated fadeInDown delayied">
            <div class="modal-vue-wrapper">
                <div class="modal-vue-header" v-if="!hideHeader">
                    <div class="row">
                        <div class="col padded" v-if="!noTitle">
                            <slot name="header">{{ header }}</slot>
                        </div>
                        <div class="col col-tight padded close" @click="closeModal">
                            <i class="fa fa-times"></i>
                        </div>
                    </div>
                </div>
    
                <div class="modal-vue-body">
                    <slot name="default" />
                </div>
    
                <div class="modal-vue-footer" v-if="!hideFooter">
                    <slot name="footer">
                        <lock-button class="col-tight" @click="closeModal" variant="subtle">
                            {{ 'Close' | i }}
                        </lock-button>
                    </slot>
                </div>
            </div>


        </div>
    </div>
</template>


<script>
export default {
    props: {
        value: {
            type: [String, Boolean, Number]
        },
        noTitle: {
            type: Boolean,
            default: false
        },
        hideFooter: {
            type: Boolean,
            default: false
        },
        hideHeader: {
            type: Boolean,
            default: false
        },
        header: {
            type: String,
            default: 'Modal'
        },
        id: {
            type: String
        }
    },
    methods: {
        reviewModalAsBodyHandler() {
            if (this.value) {
                document.body.style.overflow = "hidden";
                this.$emit('shownModal', true)
            }
            else {
                document.body.style.overflow = "";
                this.$emit('hiddenModal', false)
            }
        },
        closeModal() {
            this.$emit('hideModal', false)
            this.$emit('input', false)
        }
    },
    beforeMount() {
        this.reviewModalAsBodyHandler()
    },
    watch: {
        value() {
            this.reviewModalAsBodyHandler()
        }
    }
}
</script>

<style lang="scss">

.modal-vue {

    $fixedMargin: 6em;
    $dividingBorder: 1px solid hsla(0, 0%, 0%, 0.15);
    z-index: 10001;
    overflow-y: auto;
    font-size: 1rem;

    &,
    ::before,
    ::after {
        box-sizing: border-box;
    }

    & {
        margin: 0;
        margin-right: 0px;
        margin-left: 0px;
        padding: 0;
        box-sizing: border-box;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    &-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.35);
        backdrop-filter: blur(10px);
        z-index: -2;
    }

    .row {
        display: flex;
        flex-wrap: nowrap;
        .col {
            flex: 1;
            padding: 16px;
            &-tight {
                flex: 0 0 auto;
            }
        }
    }

    &-frame {
        margin-top: $fixedMargin;
        margin-bottom: $fixedMargin;

        .modal-vue-wrapper {
            display: flex;
            flex-direction: column;
            min-height: 10em;
            width: 80vw;
            max-width: 1080px;
            margin-left: auto;
            margin-right: auto;
            z-index: 1;
            border-radius: 16px;
            box-shadow: var(--ui-shadow);
            overflow: hidden;

            &, 
            .modal-vue-header, 
            .modal-vue-body, 
            .modal-vue-footer {
                background-color: var(--white) !important;
            }

            .modal-vue-header {
                text-transform: uppercase;
                font-weight: bolder;
                text-align: center;
                color: var(--primary);
                border-bottom: $dividingBorder;
        
                .row {
                    justify-content: end;
                }
        
                .close {
                    cursor: pointer;
                }
            }
        
            .modal-vue-body {
                padding: 1.5em;
                color: var(--primary);
            }
        
            &.no-body .modal-vue-body {
                padding: 0;
            }
        
            .modal-vue-footer {
                padding: 16px;
                display: flex;
                align-items: flex-end;
                justify-content: flex-end;
                gap: 16px;
                border-top: $dividingBorder;
                
                .button-holder {
                    margin: 0;
                    padding: 0;
                }
            }

        }
    
    }

}

.animated {
    animation-duration: 600ms;
    animation-timing-function: ease-in-out;
    animation-fill-mode: both;
}

.fadeIn {
    animation-name: fadeIn;
}

.fadeInDown {
    animation-name: fadeInDown;
}

.fadeInUp {
    animation-name: fadeInUp;
}

.slideInUp {
    animation-name: slideInUp;
}

.slideInDown {
    animation-name: slideInDown;
}



.delayied {
    animation-delay: 100ms;
}

.delayied-x2 {
    animation-delay: 200ms;
}

.delayied-x3 {
    animation-delay: 300ms;
}

@keyframes fadeInDown {
    from {
        opacity: 0;
        transform: translate(0, 102px);
    }
    to {
        opacity: 1;
        transform: translate(0, 0);
    }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translate(0, -102px);
    }
    to {
        opacity: 1;
        transform: translate(0, 0);
    }
}

@keyframes slideInUp {
    from {
        transform: translate(0, 102px);
    }
    to {
        transform: translate(0, 0);
    }
}

@keyframes slideInDown {
    from {
        transform: translate(0, -102px);
    }
    to {
        transform: translate(0, 0);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

</style>